import jsPDF from 'jspdf';
import {
  DataGridExportOptions,
  exportDataGrid,
} from 'devextreme-react/common/export/pdf';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import { Column, Row } from 'devextreme/ui/data_grid_types';
import { base64HeaderImage } from 'components/ReportGrid/constants';
import dayjs from 'dayjs';

// TODO: move to separate file
export type PDFExportProps = {
  e: DataGridTypes.ExportingEvent;
  headerTitleForSheet: string | undefined;
  reportHeaderTagLine: string | undefined;
  columns: Column[];
  rows: Row[] | undefined;
  title: string;
  pdfOrientation?: 'p' | 'portrait' | 'l' | 'landscape';
  // valuesConverter?: (rows: Row[]) => Row[];
};

type CustomizeCellOptions = Parameters<
  Required<DataGridExportOptions>['customizeCell']
>[number];

export const exportToPDF = ({
  e,
  headerTitleForSheet,
  reportHeaderTagLine,
  columns,
  rows,
  title,
  pdfOrientation = 'portrait',
}: PDFExportProps) => {
  const doc = new jsPDF({ orientation: pdfOrientation });

  doc.addImage(base64HeaderImage, 'png', 10, 15, 45, 10);
  doc.setFont('Times', undefined, 'bold').setFontSize(18);
  doc.text(headerTitleForSheet ?? 'Report', 70, 25);
  doc.setFontSize(14);
  doc.text(reportHeaderTagLine ?? '', 10, 35, { maxWidth: 280 });

  exportDataGrid({
    jsPDFDocument: doc,
    component: e.component,
    margin: { top: 50, left: 10, right: 10, bottom: 10 },
    customizeCell: ({ gridCell, pdfCell }: CustomizeCellOptions) => {
      if (pdfCell) {
        pdfCell.wordWrapEnabled = true;
        pdfCell.padding = { top: 2, bottom: 2, left: 1, right: 1 };
        pdfCell.textColor = '#000000';

      }

      if (gridCell?.rowType === 'header' && pdfCell) {
        pdfCell.font = { style: 'bold' };
        pdfCell.borderColor = '#f5f5f5';
        pdfCell.backgroundColor = '#f5f5f5';
      }

      if (gridCell?.rowType === 'data' && pdfCell) {
        pdfCell.borderColor = '#ffffff';
      }

      if (gridCell?.rowType === 'totalFooter' && pdfCell) {
        pdfCell.borderColor = '#ffffff';
      }

    },
  }).then(() => {
    doc.save(`${title + dayjs().format('DDMMYYYY')}.pdf`);
  });
};
